import { URL } from './URL';
export const ReceiptPageURL = `${URL}/payment_confirmation`;
